import { FETCH_FILTERS_VALUES } from 'actions/filtersValues';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_FILTERS_VALUES:
			return action.payload;
		default:
			return state;
	}
};